















































































































































import { CreateElement, VNode, VNodeDirective } from 'vue';
import { Component, Prop, Model, Watch, Provide } from 'vue-property-decorator';
// import { SwExtendedVue } from '../sw-extended-vue';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { SwIcon } from '@libs-uuif/shared/sw-icon';
import { CSSStyleOptions } from '@libs-uuif/shared/common-types';
import { ProvidedModalParam } from './types';
import { utilService } from '@libs-uuif/shared/util-service';
import { domService } from '@libs-uuif/shared/dom-service';

const cssPrefix = 'qsg-sw-modal';

/**
 * Events:
 * @event request-close `(open: false)`
 */
@Component({
  components: {
    SwIcon,
  },
})
export default class SwModal extends SwExtendedVue {
  @Prop({ type: String, default: 'regular' })
  mode: 'regular' | 'pillar';

  @Prop({ type: String, required: true })
  title: string;

  @Model('request-close', { type: Boolean, default: false })
  visible: boolean;

  @Prop({ type: Boolean, default: true })
  closable: boolean;

  @Prop({ type: [String, Number], default: '80%' })
  width: string | number;

  @Prop({ type: Boolean, default: true })
  vShowEnabled: boolean;

  @Provide()
  modalParam: ProvidedModalParam = {
    mode: this.mode,
  };

  cssPrefix = cssPrefix;

  rootVisible: boolean = this.visible;
  bodyStyleTicket: string = '';

  get contentStyle(): CSSStyleOptions {
    return {
      width: typeof this.width === 'number' ? `${this.width}px` : this.width,
    };
  }

  get animationName(): string {
    return this.mode === 'pillar' ? 'qsg-sw-modal-fold' : 'qsg-sw-modal-slide';
  }

  @Watch('mode')
  private syncMode(val: ProvidedModalParam['mode']) {
    this.modalParam.mode = val;
  }

  @Watch('visible')
  private onVisibleChanged(val: boolean) {
    if (val) {
      this.rootVisible = true;
    }
  }

  @Watch('rootVisible')
  private onRootVisibleChange() {
    if (this.rootVisible) {
      this.cancelCurrentBodyStyle();
      this.bodyStyleTicket = domService.stylesManager.apply(document.body, { overflowX: 'hidden', overflowY: 'hidden' });
    } else {
      this.cancelCurrentBodyStyle();
    }
  }

  private closeModal () {
    this.$emit('request-close', false);
  }

  private afterContentLeave() {
    this.rootVisible = false;
  }

  private cancelCurrentBodyStyle() {
    if (!!this.bodyStyleTicket) {
      domService.stylesManager.cancel(document.body, this.bodyStyleTicket);
      this.bodyStyleTicket = '';
    }
  }

  private render(h: CreateElement): VNode {// tslint:disable-line
    let closeNode: VNode | null = null;
    const contentNodes: VNode[] = [];

    if (this.closable) {
      closeNode = (
        <span class={[`${this.cssPrefix}__close-cont`, 'sw-flexbox__flex-none']}>
          <span
            class={[
              `${this.cssPrefix}__close`,
              'sw-flexbox', 'sw-flexbox--center-items', 'sw-flexbox--center-justify',
            ]}
            onClick={ this.closeModal }
          >
            <sw-icon name="close-thin" size={13}></sw-icon>
          </span>
        </span>
      ) as VNode;
    }

    if (this.visible || this.vShowEnabled) {
      const directives: Partial<VNodeDirective>[] = [];
      if (this.vShowEnabled) {
        directives.push({ name: 'show', value: this.visible });
      }

      contentNodes.push(
        <div class={[`${this.cssPrefix}__content`]} style={ this.contentStyle } {...{ directives }}>
          <div class={[`${this.cssPrefix}__header`, 'sw-flexbox', 'sw-flexbox--center-items']}>
            {closeNode}
          </div>
          <div class={[`${this.cssPrefix}__main-body`]}>
            {utilService.getVueScopedSlot(this.$scopedSlots)}
          </div>
        </div> as VNode,
      );
    }

    const rootNode = (
      <div class={[`${this.cssPrefix}`, `${this.cssPrefix}--${this.mode}`, 'sw-typo-default']} v-show={this.rootVisible}>
        <transition
          name={this.animationName}
          onAfterLeave={this.afterContentLeave}
        >
          {contentNodes}
        </transition>
      </div>
    );

    return rootNode as VNode;
  }

  private beforeDestroy() {
    if (!!this.bodyStyleTicket) {
      domService.stylesManager.cancel(document.body, this.bodyStyleTicket);
      this.bodyStyleTicket = '';
    }
  }
}
